'use strict';

module.exports = require('./Autosuggest').default;


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-autosuggest/dist/index.js
// module id = YWgm
// module chunks = 0